import { useCallback, useEffect, useState } from 'react'
import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { WWMXGridProps } from '../typings'

export const useRowSelection = (props: WWMXGridProps) => {
  const { loading, selectionChangeCallback = () => {} } = props

  const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>(
    [],
  )

  const onSelectionModelChange = useCallback(
    (selectionModel: GridRowSelectionModel) => {
      setSelectionModel(selectionModel)
      selectionChangeCallback(selectionModel)
    },
    [selectionChangeCallback],
  )

  useEffect(() => {
    loading && onSelectionModelChange([])
  }, [loading, onSelectionModelChange])

  return {
    selectionModel,
    onSelectionModelChange,
  }
}
